import MultiOccupancyPopup from "../../components/MultiOccupancyPopup";

export default function FloorPopupController({

    popupDesk,
    activities,
    workplaces,
    setWorkplaces,
    setPopupDesk,
    onConfirm,
    onDeselect

}) {

    function handleClose() {

        setPopupDesk(null);
    }

    function handleConfirm(
        desk,
        activityId,
        state,
        capacity
    ) {

        onConfirm(
            desk,
            activityId,
            state,
            capacity
        );

        setPopupDesk(null);
    }

    return (

        <MultiOccupancyPopup

            popupDesk={popupDesk}

            activities={activities}

            workplaces={workplaces}
            setWorkplaces={setWorkplaces}

            setPopupDesk={setPopupDesk}

            onConfirm={handleConfirm}
            onDeselect={onDeselect}

            onClose={handleClose}

        />

    );
}